// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon_icon__JKKX_","s1":"icon_s1__3ZQMc","s2":"icon_s2__QTmaM","s3":"icon_s3__d9V9C","s4":"icon_s4__cey_J","s5":"icon_s5__WddUH","s6":"icon_s6__9zfje"};